import { useEffect } from "react";
import { useAtom } from "jotai";
import { useNavigate } from "react-router";
import { isAuthenticatedAtom, currentUserAtom } from "@/hooks/use-auth";
import { clearQueryCache } from "@/lib/query-client";
import { onUserLogout } from "@/lib/sentry/sentry-user-context";
import { AUTH_CLEARED_EVENT } from "@/lib/api";

const ACCESS_TOKEN_KEY = "accessToken";

export function useAuthSync() {
  const [, setIsAuthenticated] = useAtom(isAuthenticatedAtom);
  const [, setCurrentUser] = useAtom(currentUserAtom);
  const navigate = useNavigate();

  useEffect(() => {
    function handleStorage(event: StorageEvent) {
      if (event.key !== ACCESS_TOKEN_KEY) return;

      if (event.newValue === null) {
        clearQueryCache();
        onUserLogout();
        setIsAuthenticated(false);
        setCurrentUser(null);
        navigate("/login", { replace: true });
      } else if (event.newValue !== event.oldValue) {
        window.location.reload();
      }
    }

    function handleAuthCleared() {
      clearQueryCache();
      onUserLogout();
      setIsAuthenticated(false);
      setCurrentUser(null);
    }

    window.addEventListener("storage", handleStorage);
    window.addEventListener(AUTH_CLEARED_EVENT, handleAuthCleared);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener(AUTH_CLEARED_EVENT, handleAuthCleared);
    };
  }, [navigate, setIsAuthenticated, setCurrentUser]);
}
